import { EMPTY_TRANSFER_OF_CHARGE_BULK_EDIT_CRITERIA, TransferOfChargeBulkEditCriteria } from "domain/entity/TransferOfCharge/TransferOfChargeBulkEditCriteria";
import { EMPTY_TRANSFER_OF_CHARGE_ENTITY, TransferOfChargeEntity } from "domain/entity/TransferOfCharge/TransferOfChargeEntity";
import { EMPTY_TRANSFER_OF_CHARGE_SEARCH_CRITERIA, TransferOfChargeSearchCriteria } from "domain/entity/TransferOfCharge/TransferOfChargeSearchCriteria";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";

export interface TransferOfChargeModelDropdownOptions {
    chargeTypeDropdownOptions: DropdownProps[],
    subChargeTypeDropdownOptions: { [key: string]: DropdownProps[] },

    serviceRequestCodeDropdownOptions: DropdownProps[],
    allSubReqServiceCodeDropdownOptions: DropdownProps[],
    subServiceRequestCodeDropdownOptions: { [key: string]: DropdownProps[] },

    opsLineDropdownOptions: DropdownProps[],
    chargeOnCompanyDropdownOptions: DropdownProps[],
    billToCompanyDropdownOptions: DropdownProps[],
    reasonCodeDropdownOptions: DropdownProps[],

}
export interface TransferOfChargeModelViewChangeState extends BaseViewChangeSate {
}

export interface TransferOfChargeModel {
    isLoading: boolean,
    isShowEditPanel: boolean,
    isShowSearchPanel: boolean,
    isAdd: boolean,
    isEdit: boolean,
    dynamicOptions: TransferOfChargeModelDropdownOptions,
    transferOfChargeList: TransferOfChargeEntity[],
    selectedRows: TransferOfChargeEntity[],
    currentRow: TransferOfChargeEntity,
    currentEditRow: TransferOfChargeEntity,
    searchCriteria: TransferOfChargeSearchCriteria,
    forceRefresh: boolean,
    buikEditCriteria: TransferOfChargeBulkEditCriteria,
    isUptExciseCashNo: boolean,
    isUptPaidThroughDate: boolean,
    isEditClick: boolean,
    isUptBillTo: boolean,
    isUptChargeOn: boolean,
    isSearchLoading: boolean,
    isUpdateAccTmlReasonCode: boolean,
    accResumeTerminalEnable: boolean,
    holdUnHoldEnable: boolean,
    masterState: TransferOfChargeModelViewChangeState,
}

export const EMPTY_TRANSFER_OF_CHARGE_MODEL: TransferOfChargeModel = {
    isLoading: false,
    isShowEditPanel: false,
    isAdd: false,
    isEdit: false,
    isShowSearchPanel: true,
    dynamicOptions: {
        opsLineDropdownOptions: [],
        chargeTypeDropdownOptions: [],
        subChargeTypeDropdownOptions: {},
        serviceRequestCodeDropdownOptions: [],
        subServiceRequestCodeDropdownOptions: {},
        allSubReqServiceCodeDropdownOptions: [],
        chargeOnCompanyDropdownOptions: [],
        billToCompanyDropdownOptions: [],
        reasonCodeDropdownOptions: []
    },
    transferOfChargeList: [],
    selectedRows: [],
    currentRow: { ...EMPTY_TRANSFER_OF_CHARGE_ENTITY },
    currentEditRow: { ...EMPTY_TRANSFER_OF_CHARGE_ENTITY },
    searchCriteria: { ...EMPTY_TRANSFER_OF_CHARGE_SEARCH_CRITERIA },
    forceRefresh: false,
    buikEditCriteria: { ...EMPTY_TRANSFER_OF_CHARGE_BULK_EDIT_CRITERIA },
    isUptExciseCashNo: false,
    isUptPaidThroughDate: false,
    isEditClick: false,
    isUptBillTo: false,
    isUptChargeOn: false,
    isSearchLoading: true,
    accResumeTerminalEnable: false,
    holdUnHoldEnable: false,
    isUpdateAccTmlReasonCode: false,
    masterState: {
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        }
    }
}